import React from 'react';
import HomePage from 'partners/components/pages/home';

export class Home extends React.PureComponent {
  render() {
    return <HomePage {...this.props} />;
  }
}

export default Home;
